import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '../svg-icon';

export const LightningIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 8.66667V4L5 11.3333H9.66667V16L15.6667 8.66667H11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </SvgIcon>
);
